<!DOCTYPE html>
<html>
<head>
	<meta charset="utf-8">
	<meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body>
	<div class="nav">
	<a class = "title">VeA IZI "VSRC" karšu piemēri</a>
		<label for="toggle">&#9776;</label>
		<input type="checkbox" id="toggle"/>
		<div class="menu">
			<a href="/"><span>Kartes</span></a> <!-- Nav missing tiles bug -->
			<a routerLink="/threed">Ēku 3D modeļi</a>
			<a routerLink="/about">Par pārlūku</a>
			<a routerLink="/prepared">Kā kartes tika izgatavotas</a>
		</div>
	</div>
</body>
</html>
